import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { map } from 'rxjs/operators';
import { TesterGroupSearchParam, TesterGroup } from '../models';

@Injectable({ providedIn: 'root' })
export class TesterGroupService {

  private path = '/tester_groups';

  constructor(private http: AlloxApiService) { }

  public search(param?: TesterGroupSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new TesterGroup(obj))),
    );
  }

}
